"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFeatureConfigsSymbol = exports.ConsentPolicySymbol = exports.DynamicPagesSymbol = exports.FeatureExportsSymbol = exports.FeatureStateSymbol = exports.MasterPageFeatureConfigSymbol = exports.PageFeatureConfigSymbol = exports.EditorFeatureConfigSymbol = exports.SiteFeatureConfigSymbol = void 0;
exports.SiteFeatureConfigSymbol = Symbol('SiteFeatureConfig');
exports.EditorFeatureConfigSymbol = Symbol('EditorFeatureConfig');
exports.PageFeatureConfigSymbol = Symbol('PageFeatureConfig');
exports.MasterPageFeatureConfigSymbol = Symbol('MasterPageFeatureConfig');
exports.FeatureStateSymbol = Symbol('FeatureState');
exports.FeatureExportsSymbol = Symbol('FeatureExports');
exports.DynamicPagesSymbol = Symbol('DynamicPagesSymbol');
exports.ConsentPolicySymbol = Symbol('ConsentPolicy');
exports.PageFeatureConfigsSymbol = Symbol('PageFeatureConfigs');
//# sourceMappingURL=features.js.map